module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pins/in_progress-9ad46b557d31e29805f108777d4dd077.svg";